export const PRACTICE_TEST = [
    {
        id: 1,
        test_name: 'Assessment Test',
        topic_ids: [9],
        use_practice_test_id: true,
        practice_test_id: 5,
        requires_subscription: false
    },
    {
        id: 2,
        test_name: 'Practice Test 1',
        use_practice_test_id: true,
        practice_test_id: 2,
        requires_subscription: true
    },
    {
        id: 3,
        test_name: 'Practice Test 2',
        use_practice_test_id: true,
        practice_test_id: 3,
        requires_subscription: true
    },
    {
        id: 4,
        test_name: 'Practice Test 3',
        use_practice_test_id: true,
        practice_test_id: 4,
        requires_subscription: true
    },
    {
        id: 5,
        test_name: 'Practice Test 4',
        use_practice_test_id: true,
        practice_test_id: 1,
        requires_subscription: true
    },
];

export const APP_DOMAIN_LIST = [
    {
        id: 1,
        domain_name: 'Access Controls',
        show_proficiency: true,
        icon: 'account-lock',
        requires_subscription: true,
        num_questions: 10,
        num_flashcards: 10,
        num_articles: 3,
    },
    {
        id: 2,
        domain_name: 'Security Operations and Administration',
        show_proficiency: true,
        icon: 'shield-account',
        requires_subscription: true,
        num_questions: 10,
        num_flashcards: 10,
        num_articles: 3,
    },
    {
        id: 3,
        domain_name: 'Risk Identification, Monitoring and Analysis',
        show_proficiency: true,
        icon: 'sitemap',
        requires_subscription: true,
        num_questions: 10,
        num_flashcards: 10,
        num_articles: 3,
    },
    {
        id: 4,
        domain_name: 'Incident Response and Recovery',
        show_proficiency: true,
        icon: 'shield-sync',
        requires_subscription: true,
        num_questions: 10,
        num_flashcards: 10,
        num_articles: 3,
    },
    {
        id: 5,
        domain_name: 'Cryptography',
        show_proficiency: true,
        icon: 'shield-key',
        requires_subscription: true,
        num_questions: 10,
        num_flashcards: 10,
        num_articles: 3,
    },
    {
        id: 6,
        domain_name: 'Network and Communications Security',
        show_proficiency: true,
        icon: 'security-network',
        requires_subscription: true,
        num_questions: 10,
        num_flashcards: 10,
        num_articles: 3,
    },
    {
        id: 7,
        domain_name: 'Systems and Application Security',
        show_proficiency: true,
        icon: 'cloud-lock',
        requires_subscription: true,
        num_questions: 10,
        num_flashcards: 10,
        num_articles: 3,
    },
];

export const QUESTION_VERSION_OF_JSON = 1
